<template>
    <div class="cierra-teaser-message" v-if="teaserMessageOpen">
        <div
            class="cierra-teaser-close"
            :style="{ color: backgroundColor }"
            @click="closeTeaser">
            <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 9L9 1M1 1L9 9" stroke="currentColor" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <div class="relative">
            <div class="ctw-teaser-arrow"></div>
            <div class="teaser-border ctw-rounded-md speech-bubble ctw-w-[293px] ctw-text-sm ctw-p-[14px] ctw-bg-white" @click="clickMessage">
                <span class="" :style="{color: backgroundColor}">
                    <slot></slot>
                </span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useWidgetStore } from '@/store/widget';

const widgetStore = useWidgetStore();


const teaserMessageOpen = computed(() => widgetStore.teaserMessageOpen);

const closeTeaser = () => {
    widgetStore.closeTeaser();
}

const clickMessage = () => {
    widgetStore.closeTeaser();
    widgetStore.openChat();
}

const backgroundColor = widgetStore.backgroundColor;

</script> 

<style>
.cierra-teaser-message {
  position: fixed;
  bottom: 111px;
  right: 20px;
  /* Styling */
  cursor: pointer;
  max-width: 350px;
}

.cierra-teaser-message * {
    box-sizing: border-box;
}

.cierra-teaser-close {
    position: absolute;
    top: 0px;
    right: 0px;
    transform: translate(50%, -50%);
    width: 24px;
    height: 24px;
    border-radius: 24px;
    background-color: white;
    border: 1px solid rgba(1, 24, 47, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
}

.teaser-border {
    border: 1px solid #FFFEFD0F;
}

.ctw-teaser-arrow {
    position: absolute;
    top: calc(100% - 1.6px);
    right: 20px;
    z-index: 20;
    /* Outer */
    &::after {
        content: "";
        position: absolute;
        top: -0.4px;
        right: -0.1px;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: 15px solid #FFFEFD;
    }
    /* Inner */
    &::before {
        content: "";
        position: absolute;
        top: 1px;
        right: 0;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: 15px solid #FFFEFD0F;
    }
}

</style>    